<template>
  <div class="main">
    <ui-sidebar />
    
    <router-view />
  </div>
</template>

<script>
// Modules
import UiSidebar from 'components/Sidebar';

export default {
  name: 'view-name',

  // Components
  components: {
    UiSidebar,
  },
  // Data
  // Computed
  // Methods
  // Watchers
  // Lifecycles
  // Filters
};
</script>



// WEBPACK FOOTER //
// Scheduler.vue?a95b6a98